import {Stack, useTheme} from '@mui/material';
import BarRow from './BarRow';

export interface BarLabels {
    uoa: string;
    group?: string;
    average: string;
}

interface BarChartProps {
    uoaValue: number | null;
    averageValue: number | null;
    groupValue?: number | null;
    isCount?: boolean;
    maxOverride?: number;
    labels?: BarLabels;
}

const BarChart = ({uoaValue, groupValue, averageValue, isCount = false, maxOverride, labels}: BarChartProps) => {
    const max = maxOverride ?? Math.max(uoaValue ?? 0, groupValue ?? 0, averageValue ?? 0, 1);
    const uoaPct = uoaValue !== null ? Math.min((uoaValue / max) * 100, 100) : 0;
    const groupPct = groupValue != null ? Math.min((groupValue / max) * 100, 100) : 0;
    const avgPct = averageValue !== null ? Math.min((averageValue / max) * 100, 100) : 0;
    const fmt = (v: number | null) => (v === null ? '—' : isCount ? String(v) : `${v.toFixed(2)}%`);

    const theme = useTheme();
    const uoaLabel = labels?.uoa ?? 'Il mio progetto';
    const averageLabel = labels?.average ?? 'Media dei progetti';

    const showGroup = groupValue != null && !!labels?.group;

    return (
        <Stack spacing={0.75}>
            <BarRow label={uoaLabel} pct={uoaPct} value={fmt(uoaValue)} barColor={theme.palette.primary.main} valueColor='#fff' />
            {showGroup && <BarRow label={labels!.group!} pct={groupPct} value={fmt(groupValue!)} barColor={theme.palette.grey[500]} valueColor='#fff' />}
            <BarRow label={averageLabel} pct={avgPct} value={fmt(averageValue)} barColor={theme.palette.primary.dark} valueColor='#fff' />
        </Stack>
    );
};

export default BarChart;
